import Product from '../components/Product';

export default class ProductSection {
  constructor(section) {
    const { el, data, id } = section;

    this.product = new Product(el, data, id);
  }

  onSectionUnload() {
    return this.product.unload();
  }
}
